import { useEffect, useState } from "react";
import { BELOW_DESKTOP_QUERY, isBelowDesktop } from "utils/breakpoints";

/** True while the viewport is narrower than Tailwind's `lg` breakpoint. */
export default function useIsBelowDesktop(): boolean {
  const [isBelow, setIsBelow] = useState(isBelowDesktop);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return undefined;
    const query = window.matchMedia(BELOW_DESKTOP_QUERY);
    const onChange = () => setIsBelow(query.matches);
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, []);

  return isBelow;
}
